import { combineReducers } from '@reduxjs/toolkit';

import pendingChanges from '@helsenorge/core-framework/pending-changes/pending-changes-state';
import prosesshjelp from '@helsenorge/core-framework/prosesshjelp/store';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { createLanguageReducer } from '@helsenorge/framework-utils/language';

import contentApi from './contentApi';
import tilesApi from './tilesApi';
import { resourcesApi } from '../resources';

const rootReducer = combineReducers({
  language: createLanguageReducer([LanguageLocales.NORWEGIAN, LanguageLocales.ENGLISH, LanguageLocales.SAMI_NORTHERN]),
  pendingChanges,
  prosesshjelp,
  [additionalPageContentApi.reducerPath]: additionalPageContentApi.reducer,
  [tjenesteTeksterApi.reducerPath]: tjenesteTeksterApi.reducer,
  [contentApi.reducerPath]: contentApi.reducer,
  [tilesApi.reducerPath]: tilesApi.reducer,
  [resourcesApi.reducerPath]: resourcesApi.reducer,
});

export default rootReducer;
